import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface AdminState {
    logged: boolean;
    host_id?: number;
    host_name?: string;
    host_mail?: string;
    host_uid?: string;
    /** M4: scadenza della sessione (epoch in secondi) per l'idratazione locale. */
    exp?: number;
}

/**
 * Stato iniziale del slice, riusato dal `preloadedState` dello store quando in
 * localStorage non c'è una sessione valida (A4).
 */
export const initialAdminState: AdminState = {
    logged: false,
};

export const adminSlice = createSlice({
    name: 'admin',
    initialState: initialAdminState,
    reducers: {
        setAdmin: (state, action: PayloadAction<AdminState>) => {
            state.logged = Boolean(action.payload.logged);
            state.host_id = action.payload.host_id;
            state.host_name = action.payload.host_name;
            state.host_mail = action.payload.host_mail;
            state.host_uid = action.payload.host_uid;
            state.exp = action.payload.exp;
        },
        logout: () => initialAdminState,
    },
});

export const { setAdmin, logout } = adminSlice.actions;
export default adminSlice.reducer;
